import React, { useState, useEffect, createContext, useContext } from 'react';

// Context for milestone notifications
const MilestoneContext = createContext();

export const useMilestoneToast = () => useContext(MilestoneContext);

export const MilestoneProvider = ({ children }) => {
  const [milestone, setMilestone] = useState(null);
  const [visible, setVisible] = useState(false);

  const showMilestone = (milestoneData) => {
    setMilestone(milestoneData);
    setVisible(true);
    setTimeout(() => setVisible(false), 5000);
  };

  const checkForNewMilestones = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    
    try {
      const res = await fetch('/api/v1/journey/milestones/check', {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.new_milestones && data.new_milestones.length > 0) {
        data.new_milestones.forEach((m, i) => {
          setTimeout(() => showMilestone(m), i * 2000);
        });
      }
    } catch (err) {
      console.log('Milestone check failed:', err);
    }
  };

  return (
    <MilestoneContext.Provider value={{ showMilestone, checkForNewMilestones }}>
      {children}
      {visible && milestone && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '20px 24px',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(102, 126, 234, 0.4)',
          zIndex: 9999,
          animation: 'slideIn 0.5s ease-out',
          maxWidth: '320px'
        }}>
          <div style={{ fontSize: '28px', marginBottom: '8px' }}>🏆</div>
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>
            Milestone Unlocked!
          </div>
          <div style={{ fontSize: '18px', fontWeight: '600' }}>
            {milestone.name || milestone.milestone_name}
          </div>
          <div style={{ fontSize: '13px', opacity: 0.9, marginTop: '4px' }}>
            +{milestone.points || milestone.points_awarded} points
          </div>
        </div>
      )}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </MilestoneContext.Provider>
  );
};

export default MilestoneProvider;
